/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 10:52:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 12:57:49
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/HomepageSEOSetting/index.tsx
 */
/**
 *  Seo Setting
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';

import css from './css.less';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { get } from 'lodash';
import { Input, TextArea } from 'src/components/Antd';
import CountWordsWithFormItem from 'src/components/CountWords/CountWordsWithFormItem';
import { Field } from 'src/components/RcForm';
import Slug from 'src/constrains/SlugInput';
import { seoSettingKey } from './constant';
import { validateSlug } from './validator';
// import { useSubscription } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepageResponsive/hooks/useSubscription';
// import TermsAndConditions from 'src/components/Modules-revamp/TermsAndConditions';
// import { EPreviewSize } from 'src/types/common/SalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const HomePageSEOSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // urlSlug: slug, slugValid: valid
  const { contentUuid, uuid, isPrimary } = props;
  // const { handleOnTcReselect, tcsOptions, handleOnDelete, handleOnSort } =
  //   useSubscription();
  return (
    <div className={css.container}>
      <Section>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.pageTitle')}
          rightPart={
            <CountWordsWithFormItem
              maxCount={100}
              keyName={seoSettingKey.title}
            />
          }>
          <Field name={seoSettingKey.title}>
            <Input
              // value={title}
              // onChange={onTitleChange}
              size='large'
              placeholder={`${getI18n('general.customer.title')} (0/100)`}
              maxLength={100}
            />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          rightPart={
            <CountWordsWithFormItem
              maxCount={500}
              keyName={seoSettingKey.description}
            />
          }
          title={getI18n('salesChannelContent.index.pageMetaDescription')}>
          <Field name={seoSettingKey.description}>
            <TextArea
              maxLength={500}
              placeholder={`${getI18n(
                'salesChannelContent.index.pageMetaDescription',
              )} (0/500)`}
            />
          </Field>
        </ItemWrapper>
        {isPrimary && (
          <Field name={seoSettingKey.slug}>
            {(slugProps, m) => {
              return (
                <Field
                  name={seoSettingKey.slugValid}
                  rules={[
                    {
                      // validateTrigger: 'onSubmit',
                      validator: async (rules: any, value: any) => {
                        if (validateSlug) {
                          const res = validateSlug(value);
                          const hasError = get(res, 'hasError');
                          const errors = get(res, 'errors');
                          if (hasError) {
                            return Promise.reject(
                              new Error((errors || []).join(',')),
                            );
                          }
                        }
                      },
                    },
                  ]}>
                  {(validProps, validM) => {
                    return (
                      <Slug
                        containerClassName={css.slugContainer}
                        value={slugProps.value}
                        displayDangerousNotice
                        url={'portal/contentPage/slug/duplicate'}
                        slugValid={validProps.value}
                        fixedParams={{
                          contentUuid: contentUuid,
                          pageUuid: uuid,
                        }}
                        onChange={({ slug, valid }) => {
                          slugProps.onChange(slug);
                          validProps.onChange(valid);
                        }}
                      />
                    );
                  }}
                </Field>
              );
            }}
          </Field>
        )}
      </Section>
    </div>
  );
};
export default HomePageSEOSetting;
